const ACTION_TYPES = Object.freeze({
  CORRECT: "correct",
  INCORRECT: "incorrect",
  END_GAME: "endGame",
});
export { ACTION_TYPES };
